"use client";

import { useEffect, useState } from "react";
import { cn } from "~/utils/fontsConfig";

import { NotificationSheet } from "./NotificationSheet";
import { If } from "../../v3/Conditional";
import { NotificationIcon } from "~/app/_components/Icons";
import { useRouter, useSearchParams } from "next/navigation";

type Props = {
    count: number;
    isUrlTriggable?: boolean;
};

export const NotificationMenu = ({ count, isUrlTriggable = false }: Props) => {
    const [showNotifications, setShowNotifications] = useState(false);
    const searchParams = useSearchParams();
    const router = useRouter();

    const toggleShowNotifications = () => {
        setShowNotifications((prev) => !prev);
    };
    const shouldOpenNotifications = searchParams?.get("showNotifications");

    useEffect(() => {
        if (!isUrlTriggable || shouldOpenNotifications !== "true") return;
        setShowNotifications(true);
        // rm showNotifications from the url
        const params = new URLSearchParams(searchParams!);
        params.delete("showNotifications");
        router.replace(`?${params.toString()}`, { scroll: false });
    }, [shouldOpenNotifications]); // no dependencies (run once)

    return (
        <div>
            <div className="cursor-pointer" onClick={toggleShowNotifications}>
                {count > 0 ? (
                    <div className="relative">
                        <NotificationIcon className="text-2xl" fill="white" />
                        <div
                            className={cn(
                                `
							absolute -right-2 -top-2
							flex h-4 w-4
							items-center justify-center
							rounded-full bg-red-500`,
                                count > 10 ? "text-[8px]" : "text-xs",
                            )}
                        >
                            <If condition={count > 99}>99+</If>
                            <If condition={count < 99}>{count}</If>
                        </div>
                    </div>
                ) : (
                    <NotificationIcon className="text-2xl" fill="white" />
                )}
            </div>

            <NotificationSheet
                isOpen={showNotifications}
                setOpen={(val) => setShowNotifications(val)}
            />
        </div>
    );
};
